// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension="
// @generated from file aiChat.proto (package aiChat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from '@bufbuild/protobuf'
import { Message, proto3, Struct } from '@bufbuild/protobuf'
import { Error } from './core_pb'
import { AiChatEvent, AiChatSession } from './_gen.models_pb'

/**
 * @generated from message aiChat.v1.AiChatParamDefinition
 */
export class AiChatParamDefinition extends Message<AiChatParamDefinition> {
  /**
   * @generated from field: string description = 1;
   */
  description = ''

  /**
   * @generated from oneof aiChat.v1.AiChatParamDefinition.param_type
   */
  paramType:
    | {
        /**
         * @generated from field: aiChat.v1.AiChatParamDefinitionPrimitive primitive = 2;
         */
        value: AiChatParamDefinitionPrimitive
        case: 'primitive'
      }
    | {
        /**
         * @generated from field: aiChat.v1.AiChatParamDefinitionObject object = 3;
         */
        value: AiChatParamDefinitionObject
        case: 'object'
      }
    | {
        /**
         * @generated from field: aiChat.v1.AiChatParamDefinitionArray array = 4;
         */
        value: AiChatParamDefinitionArray
        case: 'array'
      }
    | { case: undefined; value?: undefined } = { case: undefined }

  constructor(data?: PartialMessage<AiChatParamDefinition>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.AiChatParamDefinition'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'primitive', kind: 'message', T: AiChatParamDefinitionPrimitive, oneof: 'param_type' },
    { no: 3, name: 'object', kind: 'message', T: AiChatParamDefinitionObject, oneof: 'param_type' },
    { no: 4, name: 'array', kind: 'message', T: AiChatParamDefinitionArray, oneof: 'param_type' },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AiChatParamDefinition {
    return new AiChatParamDefinition().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AiChatParamDefinition {
    return new AiChatParamDefinition().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AiChatParamDefinition {
    return new AiChatParamDefinition().fromJsonString(jsonString, options)
  }

  static equals(
    a: AiChatParamDefinition | PlainMessage<AiChatParamDefinition> | undefined,
    b: AiChatParamDefinition | PlainMessage<AiChatParamDefinition> | undefined,
  ): boolean {
    return proto3.util.equals(AiChatParamDefinition, a, b)
  }
}

/**
 * @generated from message aiChat.v1.AiChatParamDefinitionPrimitive
 */
export class AiChatParamDefinitionPrimitive extends Message<AiChatParamDefinitionPrimitive> {
  /**
   * 'string' | 'number' | 'boolean'
   *
   * @generated from field: string type = 1;
   */
  type = ''

  /**
   * @generated from field: repeated string enumValues = 2;
   */
  enumValues: string[] = []

  constructor(data?: PartialMessage<AiChatParamDefinitionPrimitive>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.AiChatParamDefinitionPrimitive'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'type', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'enumValues', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AiChatParamDefinitionPrimitive {
    return new AiChatParamDefinitionPrimitive().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AiChatParamDefinitionPrimitive {
    return new AiChatParamDefinitionPrimitive().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AiChatParamDefinitionPrimitive {
    return new AiChatParamDefinitionPrimitive().fromJsonString(jsonString, options)
  }

  static equals(
    a: AiChatParamDefinitionPrimitive | PlainMessage<AiChatParamDefinitionPrimitive> | undefined,
    b: AiChatParamDefinitionPrimitive | PlainMessage<AiChatParamDefinitionPrimitive> | undefined,
  ): boolean {
    return proto3.util.equals(AiChatParamDefinitionPrimitive, a, b)
  }
}

/**
 * @generated from message aiChat.v1.AiChatParamDefinitionObject
 */
export class AiChatParamDefinitionObject extends Message<AiChatParamDefinitionObject> {
  /**
   * 'object'
   *
   * @generated from field: string type = 1;
   */
  type = ''

  /**
   * @generated from field: map<string, aiChat.v1.AiChatParamDefinition> properties = 2;
   */
  properties: { [key: string]: AiChatParamDefinition } = {}

  /**
   * always false
   *
   * @generated from field: bool additionalProperties = 3;
   */
  additionalProperties = false

  /**
   * @generated from field: repeated string required = 4;
   */
  required: string[] = []

  constructor(data?: PartialMessage<AiChatParamDefinitionObject>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.AiChatParamDefinitionObject'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'type', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'properties', kind: 'map', K: 9 /* ScalarType.STRING */, V: { kind: 'message', T: AiChatParamDefinition } },
    { no: 3, name: 'additionalProperties', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: 'required', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AiChatParamDefinitionObject {
    return new AiChatParamDefinitionObject().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AiChatParamDefinitionObject {
    return new AiChatParamDefinitionObject().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AiChatParamDefinitionObject {
    return new AiChatParamDefinitionObject().fromJsonString(jsonString, options)
  }

  static equals(
    a: AiChatParamDefinitionObject | PlainMessage<AiChatParamDefinitionObject> | undefined,
    b: AiChatParamDefinitionObject | PlainMessage<AiChatParamDefinitionObject> | undefined,
  ): boolean {
    return proto3.util.equals(AiChatParamDefinitionObject, a, b)
  }
}

/**
 * @generated from message aiChat.v1.AiChatParamDefinitionArray
 */
export class AiChatParamDefinitionArray extends Message<AiChatParamDefinitionArray> {
  /**
   * 'array'
   *
   * @generated from field: string type = 1;
   */
  type = ''

  /**
   * @generated from field: aiChat.v1.AiChatParamDefinition items = 2;
   */
  items?: AiChatParamDefinition

  constructor(data?: PartialMessage<AiChatParamDefinitionArray>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.AiChatParamDefinitionArray'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'type', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'items', kind: 'message', T: AiChatParamDefinition },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AiChatParamDefinitionArray {
    return new AiChatParamDefinitionArray().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AiChatParamDefinitionArray {
    return new AiChatParamDefinitionArray().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AiChatParamDefinitionArray {
    return new AiChatParamDefinitionArray().fromJsonString(jsonString, options)
  }

  static equals(
    a: AiChatParamDefinitionArray | PlainMessage<AiChatParamDefinitionArray> | undefined,
    b: AiChatParamDefinitionArray | PlainMessage<AiChatParamDefinitionArray> | undefined,
  ): boolean {
    return proto3.util.equals(AiChatParamDefinitionArray, a, b)
  }
}

/**
 * @generated from message aiChat.v1.AiChatAvailableAction
 */
export class AiChatAvailableAction extends Message<AiChatAvailableAction> {
  /**
   * @generated from field: string action_type = 1;
   */
  actionType = ''

  /**
   * @generated from field: string description = 2;
   */
  description = ''

  /**
   * @generated from field: string displayTextForUser = 3;
   */
  displayTextForUser = ''

  /**
   * @generated from field: google.protobuf.Struct parameterDefinition = 4;
   */
  parameterDefinition?: Struct

  constructor(data?: PartialMessage<AiChatAvailableAction>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.AiChatAvailableAction'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'action_type', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'displayTextForUser', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'parameterDefinition', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AiChatAvailableAction {
    return new AiChatAvailableAction().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AiChatAvailableAction {
    return new AiChatAvailableAction().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AiChatAvailableAction {
    return new AiChatAvailableAction().fromJsonString(jsonString, options)
  }

  static equals(
    a: AiChatAvailableAction | PlainMessage<AiChatAvailableAction> | undefined,
    b: AiChatAvailableAction | PlainMessage<AiChatAvailableAction> | undefined,
  ): boolean {
    return proto3.util.equals(AiChatAvailableAction, a, b)
  }
}

/**
 * @generated from message aiChat.v1.AiChatPageContext
 */
export class AiChatPageContext extends Message<AiChatPageContext> {
  /**
   * @generated from field: string title = 1;
   */
  title = ''

  /**
   * @generated from field: string html = 2;
   */
  html = ''

  /**
   * @generated from field: string url = 3;
   */
  url = ''

  constructor(data?: PartialMessage<AiChatPageContext>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.AiChatPageContext'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'html', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'url', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AiChatPageContext {
    return new AiChatPageContext().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AiChatPageContext {
    return new AiChatPageContext().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AiChatPageContext {
    return new AiChatPageContext().fromJsonString(jsonString, options)
  }

  static equals(
    a: AiChatPageContext | PlainMessage<AiChatPageContext> | undefined,
    b: AiChatPageContext | PlainMessage<AiChatPageContext> | undefined,
  ): boolean {
    return proto3.util.equals(AiChatPageContext, a, b)
  }
}

/**
 * @generated from message aiChat.v1.AiChatEventPayloadClientInfo
 */
export class AiChatEventPayloadClientInfo extends Message<AiChatEventPayloadClientInfo> {
  /**
   * "clientInfo"
   *
   * @generated from field: string type = 1;
   */
  type = ''

  /**
   * @generated from field: aiChat.v1.AiChatPageContext pageContext = 2;
   */
  pageContext?: AiChatPageContext

  /**
   * @generated from field: repeated aiChat.v1.AiChatAvailableAction availableActions = 3;
   */
  availableActions: AiChatAvailableAction[] = []

  constructor(data?: PartialMessage<AiChatEventPayloadClientInfo>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.AiChatEventPayloadClientInfo'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'type', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'pageContext', kind: 'message', T: AiChatPageContext },
    { no: 3, name: 'availableActions', kind: 'message', T: AiChatAvailableAction, repeated: true },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AiChatEventPayloadClientInfo {
    return new AiChatEventPayloadClientInfo().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AiChatEventPayloadClientInfo {
    return new AiChatEventPayloadClientInfo().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AiChatEventPayloadClientInfo {
    return new AiChatEventPayloadClientInfo().fromJsonString(jsonString, options)
  }

  static equals(
    a: AiChatEventPayloadClientInfo | PlainMessage<AiChatEventPayloadClientInfo> | undefined,
    b: AiChatEventPayloadClientInfo | PlainMessage<AiChatEventPayloadClientInfo> | undefined,
  ): boolean {
    return proto3.util.equals(AiChatEventPayloadClientInfo, a, b)
  }
}

/**
 * StartAiChatSession
 *
 * @generated from message aiChat.v1.StartAiChatSessionRequest
 */
export class StartAiChatSessionRequest extends Message<StartAiChatSessionRequest> {
  /**
   * @generated from field: string userId = 1;
   */
  userId = ''

  /**
   * @generated from field: aiChat.v1.AiChatEventPayloadClientInfo initialClientInfo = 2;
   */
  initialClientInfo?: AiChatEventPayloadClientInfo

  /**
   * @generated from field: optional string userMessage = 3;
   */
  userMessage?: string

  constructor(data?: PartialMessage<StartAiChatSessionRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.StartAiChatSessionRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'userId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'initialClientInfo', kind: 'message', T: AiChatEventPayloadClientInfo },
    { no: 3, name: 'userMessage', kind: 'scalar', T: 9 /* ScalarType.STRING */, opt: true },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartAiChatSessionRequest {
    return new StartAiChatSessionRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartAiChatSessionRequest {
    return new StartAiChatSessionRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartAiChatSessionRequest {
    return new StartAiChatSessionRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: StartAiChatSessionRequest | PlainMessage<StartAiChatSessionRequest> | undefined,
    b: StartAiChatSessionRequest | PlainMessage<StartAiChatSessionRequest> | undefined,
  ): boolean {
    return proto3.util.equals(StartAiChatSessionRequest, a, b)
  }
}

/**
 * @generated from message aiChat.v1.StartAiChatSessionResponse
 */
export class StartAiChatSessionResponse extends Message<StartAiChatSessionResponse> {
  /**
   * @generated from field: string sessionId = 1;
   */
  sessionId = ''

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<StartAiChatSessionResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.StartAiChatSessionResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'sessionId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartAiChatSessionResponse {
    return new StartAiChatSessionResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartAiChatSessionResponse {
    return new StartAiChatSessionResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartAiChatSessionResponse {
    return new StartAiChatSessionResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: StartAiChatSessionResponse | PlainMessage<StartAiChatSessionResponse> | undefined,
    b: StartAiChatSessionResponse | PlainMessage<StartAiChatSessionResponse> | undefined,
  ): boolean {
    return proto3.util.equals(StartAiChatSessionResponse, a, b)
  }
}

/**
 * SendMessage
 *
 * @generated from message aiChat.v1.SendMessageRequest
 */
export class SendMessageRequest extends Message<SendMessageRequest> {
  /**
   * @generated from field: string sessionId = 1;
   */
  sessionId = ''

  /**
   * @generated from field: string userId = 2;
   */
  userId = ''

  /**
   * @generated from field: string content = 3;
   */
  content = ''

  /**
   * @generated from field: optional aiChat.v1.AiChatEventPayloadClientInfo clientInfo = 4;
   */
  clientInfo?: AiChatEventPayloadClientInfo

  constructor(data?: PartialMessage<SendMessageRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.SendMessageRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'sessionId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'userId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'content', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'clientInfo', kind: 'message', T: AiChatEventPayloadClientInfo, opt: true },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendMessageRequest {
    return new SendMessageRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendMessageRequest {
    return new SendMessageRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendMessageRequest {
    return new SendMessageRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: SendMessageRequest | PlainMessage<SendMessageRequest> | undefined,
    b: SendMessageRequest | PlainMessage<SendMessageRequest> | undefined,
  ): boolean {
    return proto3.util.equals(SendMessageRequest, a, b)
  }
}

/**
 * @generated from message aiChat.v1.SendMessageResponse
 */
export class SendMessageResponse extends Message<SendMessageResponse> {
  /**
   * @generated from field: string eventId = 1;
   */
  eventId = ''

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<SendMessageResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.SendMessageResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'eventId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendMessageResponse {
    return new SendMessageResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendMessageResponse {
    return new SendMessageResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendMessageResponse {
    return new SendMessageResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: SendMessageResponse | PlainMessage<SendMessageResponse> | undefined,
    b: SendMessageResponse | PlainMessage<SendMessageResponse> | undefined,
  ): boolean {
    return proto3.util.equals(SendMessageResponse, a, b)
  }
}

/**
 * SubscribeAiChatEvents
 *
 * @generated from message aiChat.v1.SubscribeAiChatEventsRequest
 */
export class SubscribeAiChatEventsRequest extends Message<SubscribeAiChatEventsRequest> {
  /**
   * @generated from field: string sessionId = 1;
   */
  sessionId = ''

  /**
   * @generated from field: string userId = 2;
   */
  userId = ''

  /**
   * @generated from field: optional int32 fromEventIndex = 3;
   */
  fromEventIndex?: number

  constructor(data?: PartialMessage<SubscribeAiChatEventsRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.SubscribeAiChatEventsRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'sessionId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'userId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'fromEventIndex', kind: 'scalar', T: 5 /* ScalarType.INT32 */, opt: true },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscribeAiChatEventsRequest {
    return new SubscribeAiChatEventsRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscribeAiChatEventsRequest {
    return new SubscribeAiChatEventsRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscribeAiChatEventsRequest {
    return new SubscribeAiChatEventsRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: SubscribeAiChatEventsRequest | PlainMessage<SubscribeAiChatEventsRequest> | undefined,
    b: SubscribeAiChatEventsRequest | PlainMessage<SubscribeAiChatEventsRequest> | undefined,
  ): boolean {
    return proto3.util.equals(SubscribeAiChatEventsRequest, a, b)
  }
}

/**
 * @generated from message aiChat.v1.SubscribeAiChatEventsResponse
 */
export class SubscribeAiChatEventsResponse extends Message<SubscribeAiChatEventsResponse> {
  /**
   * @generated from field: models.AiChatEvent event = 1;
   */
  event?: AiChatEvent

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<SubscribeAiChatEventsResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.SubscribeAiChatEventsResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'event', kind: 'message', T: AiChatEvent },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscribeAiChatEventsResponse {
    return new SubscribeAiChatEventsResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscribeAiChatEventsResponse {
    return new SubscribeAiChatEventsResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscribeAiChatEventsResponse {
    return new SubscribeAiChatEventsResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: SubscribeAiChatEventsResponse | PlainMessage<SubscribeAiChatEventsResponse> | undefined,
    b: SubscribeAiChatEventsResponse | PlainMessage<SubscribeAiChatEventsResponse> | undefined,
  ): boolean {
    return proto3.util.equals(SubscribeAiChatEventsResponse, a, b)
  }
}

/**
 * SubscribeAiChatEventById
 *
 * @generated from message aiChat.v1.SubscribeAiChatEventByIdRequest
 */
export class SubscribeAiChatEventByIdRequest extends Message<SubscribeAiChatEventByIdRequest> {
  /**
   * @generated from field: string aiChatEventId = 1;
   */
  aiChatEventId = ''

  constructor(data?: PartialMessage<SubscribeAiChatEventByIdRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.SubscribeAiChatEventByIdRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [{ no: 1, name: 'aiChatEventId', kind: 'scalar', T: 9 /* ScalarType.STRING */ }])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscribeAiChatEventByIdRequest {
    return new SubscribeAiChatEventByIdRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscribeAiChatEventByIdRequest {
    return new SubscribeAiChatEventByIdRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscribeAiChatEventByIdRequest {
    return new SubscribeAiChatEventByIdRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: SubscribeAiChatEventByIdRequest | PlainMessage<SubscribeAiChatEventByIdRequest> | undefined,
    b: SubscribeAiChatEventByIdRequest | PlainMessage<SubscribeAiChatEventByIdRequest> | undefined,
  ): boolean {
    return proto3.util.equals(SubscribeAiChatEventByIdRequest, a, b)
  }
}

/**
 * @generated from message aiChat.v1.SubscribeAiChatEventByIdResponse
 */
export class SubscribeAiChatEventByIdResponse extends Message<SubscribeAiChatEventByIdResponse> {
  /**
   * @generated from field: models.AiChatEvent aiChatEvent = 1;
   */
  aiChatEvent?: AiChatEvent

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<SubscribeAiChatEventByIdResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.SubscribeAiChatEventByIdResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'aiChatEvent', kind: 'message', T: AiChatEvent },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscribeAiChatEventByIdResponse {
    return new SubscribeAiChatEventByIdResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscribeAiChatEventByIdResponse {
    return new SubscribeAiChatEventByIdResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscribeAiChatEventByIdResponse {
    return new SubscribeAiChatEventByIdResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: SubscribeAiChatEventByIdResponse | PlainMessage<SubscribeAiChatEventByIdResponse> | undefined,
    b: SubscribeAiChatEventByIdResponse | PlainMessage<SubscribeAiChatEventByIdResponse> | undefined,
  ): boolean {
    return proto3.util.equals(SubscribeAiChatEventByIdResponse, a, b)
  }
}

/**
 * SubscribeAiChatSession
 *
 * @generated from message aiChat.v1.SubscribeAiChatSessionRequest
 */
export class SubscribeAiChatSessionRequest extends Message<SubscribeAiChatSessionRequest> {
  /**
   * @generated from field: string sessionId = 1;
   */
  sessionId = ''

  constructor(data?: PartialMessage<SubscribeAiChatSessionRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.SubscribeAiChatSessionRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [{ no: 1, name: 'sessionId', kind: 'scalar', T: 9 /* ScalarType.STRING */ }])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscribeAiChatSessionRequest {
    return new SubscribeAiChatSessionRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscribeAiChatSessionRequest {
    return new SubscribeAiChatSessionRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscribeAiChatSessionRequest {
    return new SubscribeAiChatSessionRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: SubscribeAiChatSessionRequest | PlainMessage<SubscribeAiChatSessionRequest> | undefined,
    b: SubscribeAiChatSessionRequest | PlainMessage<SubscribeAiChatSessionRequest> | undefined,
  ): boolean {
    return proto3.util.equals(SubscribeAiChatSessionRequest, a, b)
  }
}

/**
 * @generated from message aiChat.v1.SubscribeAiChatSessionResponse
 */
export class SubscribeAiChatSessionResponse extends Message<SubscribeAiChatSessionResponse> {
  /**
   * @generated from field: models.AiChatSession session = 1;
   */
  session?: AiChatSession

  /**
   * @generated from field: repeated string aiChatEventIds = 2;
   */
  aiChatEventIds: string[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<SubscribeAiChatSessionResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.SubscribeAiChatSessionResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'session', kind: 'message', T: AiChatSession },
    { no: 2, name: 'aiChatEventIds', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscribeAiChatSessionResponse {
    return new SubscribeAiChatSessionResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscribeAiChatSessionResponse {
    return new SubscribeAiChatSessionResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscribeAiChatSessionResponse {
    return new SubscribeAiChatSessionResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: SubscribeAiChatSessionResponse | PlainMessage<SubscribeAiChatSessionResponse> | undefined,
    b: SubscribeAiChatSessionResponse | PlainMessage<SubscribeAiChatSessionResponse> | undefined,
  ): boolean {
    return proto3.util.equals(SubscribeAiChatSessionResponse, a, b)
  }
}

/**
 * UpdateClientInfo
 *
 * @generated from message aiChat.v1.UpdateClientInfoRequest
 */
export class UpdateClientInfoRequest extends Message<UpdateClientInfoRequest> {
  /**
   * @generated from field: string sessionId = 1;
   */
  sessionId = ''

  /**
   * @generated from field: string userId = 2;
   */
  userId = ''

  /**
   * @generated from field: aiChat.v1.AiChatEventPayloadClientInfo clientInfo = 3;
   */
  clientInfo?: AiChatEventPayloadClientInfo

  constructor(data?: PartialMessage<UpdateClientInfoRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.UpdateClientInfoRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'sessionId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'userId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'clientInfo', kind: 'message', T: AiChatEventPayloadClientInfo },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateClientInfoRequest {
    return new UpdateClientInfoRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateClientInfoRequest {
    return new UpdateClientInfoRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateClientInfoRequest {
    return new UpdateClientInfoRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: UpdateClientInfoRequest | PlainMessage<UpdateClientInfoRequest> | undefined,
    b: UpdateClientInfoRequest | PlainMessage<UpdateClientInfoRequest> | undefined,
  ): boolean {
    return proto3.util.equals(UpdateClientInfoRequest, a, b)
  }
}

/**
 * @generated from message aiChat.v1.UpdateClientInfoResponse
 */
export class UpdateClientInfoResponse extends Message<UpdateClientInfoResponse> {
  /**
   * @generated from field: string eventId = 1;
   */
  eventId = ''

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<UpdateClientInfoResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'aiChat.v1.UpdateClientInfoResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'eventId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateClientInfoResponse {
    return new UpdateClientInfoResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateClientInfoResponse {
    return new UpdateClientInfoResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateClientInfoResponse {
    return new UpdateClientInfoResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: UpdateClientInfoResponse | PlainMessage<UpdateClientInfoResponse> | undefined,
    b: UpdateClientInfoResponse | PlainMessage<UpdateClientInfoResponse> | undefined,
  ): boolean {
    return proto3.util.equals(UpdateClientInfoResponse, a, b)
  }
}
